import { useToast } from '../context/ToastContext';

// Module-level timestamp so the throttle is SHARED across every caller
// A viewer mashing keys in a cell (or anywhere) sees at most one "view-only" toast per window.
let lastShownAt = 0;
const THROTTLE_MS = 3000;

export function useReadOnlyToast() {
    const { showToast } = useToast();

    return () => {
        const now = Date.now();
        if (now - lastShownAt < THROTTLE_MS) return;
        lastShownAt = now;
        showToast('You have view-only access to this trip', 'info');
    };
}
